import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from './useSession';

// The SuperTokens <SessionAuth>: signed-out users go to /auth and come back afterwards.
export const RequireSession: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const session = useSession();
    const location = useLocation();
    if (session === undefined) {
        return null;
    }
    if (!session) {
        const redirectToPath = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/auth?redirectToPath=${redirectToPath}`} replace />;
    }
    return <>{children}</>;
};
